import React from 'react'
import clsx from 'clsx'
import { RatingContext } from '../../utils/RatingContext'
import { useFormContext } from 'react-hook-form'
import { useSpring, animated } from 'react-spring'
import styles from '../../assets/styles/styles.module.css'
import { TEXT } from '../../i18n/text'
import { MAX_FEEDBACK_LENGTH, normalizeFeedback } from '../../utils/feedbackValidation'

import { PHeading, PText, PTextareaWrapper } from '@porsche-design-system/components-react'
import { StarRating } from './StarRating'

export const RatingGuided = (): React.ReactElement => {

    const guidedToggle = React.useContext(RatingContext).guidedToggle
    const language = React.useContext(RatingContext).language
    const { register, formState: { errors } } = useFormContext()

    const fadeOut = useSpring({
        opacity: guidedToggle ? 0 : 1,
        height: guidedToggle ? 0 : 70
    })
    const fadeIn = useSpring({
        opacity: guidedToggle ? 1 : 0,
        height: guidedToggle ? 70 : 0
    })

    return (
        <div className={clsx(styles.content, styles.contentFullHeight)}>
            <animated.div style={fadeOut}>
                <PText className={styles.spacingL}>{TEXT[language].text}</PText>
            </animated.div>
            <div className={clsx(styles.flexContainer, styles.flexAlignCenter, styles.spacingL)}>
                <PHeading tag='h5' size='small' className={styles.feedbackTitle}>
                    {TEXT[language].feedback}
                </PHeading>
                <div className={styles.foreGround}>
                    <StarRating />
                </div>
            </div>
            <animated.div style={fadeIn}>
                <PText>{TEXT[language].reasons}</PText>
            </animated.div>
            <animated.div style={fadeIn}>
                <PTextareaWrapper className={clsx(styles.spacingL, styles.smaller)} hideLabel>
                    <textarea
                        {...register("comment", {
                            maxLength: {
                                value: MAX_FEEDBACK_LENGTH,
                                message: TEXT[language].feedbackErrorTooLong
                            },
                            setValueAs: normalizeFeedback
                        })}
                        placeholder={TEXT[language].textareaPlaceholder} />
                    <PText size="xx-small">{TEXT[language].textareaHint}</PText>
                    {errors.comment?.message && (
                        <PText color='brand' size="xx-small" className={styles.fieldError}>
                            {String(errors.comment.message)}
                        </PText>
                    )}
                </PTextareaWrapper>
            </animated.div>
        </div>
    )
}
